export default __webpack_public_path__ + "static/media/JavaScript frameworks-pana.d4ac1847.svg";